import _typeof from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var state = {
  contacterInfo: {
    wechat: [],
    email: [],
    phone: []
  },
  // contacterWechat 是从UPSID 获取到的微信(做这一块的时候避免和上面的contacterInfo wechat弄混)
  // 这里是显示在联系人的地方的而上面的是显示在发送至， 联系人这里要区分寄件收件
  contacterWechat: {
    shipFrom: [],
    shipTo: []
  },
  // 电话号码添加
  contacterPhone: {
    fromPhone: [],
    toPhone: []
  },
  contacterEmail: {
    shipFrom: [],
    shipTo: []
  }
};
var mutations = {
  addInfo: function addInfo(state, payload) {
    // payload.contacterType 寄件人还是收件人, data是数组来的
    var copyContacterInfo = _toConsumableArray(state.contacterInfo[payload.contacterType]);
    var colorList = ['#C67D30', '#426DA9', '#76881D', '#00857D', '#595555', '#FFD100'];
    var classList = ['color1', 'color2', 'color3', 'color4', 'color5', 'color6'];
    var index = Math.floor(Math.random() * colorList.length);
    var filterPayload = payload.data.filter(function (payloadItem) {
      return !copyContacterInfo.some(function (infoItem) {
        if (payload.contacterType === 'wechat') {
          if (infoItem.item.openId) {
            return infoItem.item.openId === payloadItem.openId;
          } else if (payloadItem.openId) {
            return infoItem.item === payloadItem.openId;
          } else {
            return infoItem.item === payloadItem;
          }
        } else {
          return payloadItem === infoItem.item;
        }
      });
    });
    var addColor = filterPayload.map(function (item) {
      return {
        item: item,
        colorName: classList[index]
      };
    });
    state.contacterInfo[payload.contacterType] = Array.from(new Set([].concat(_toConsumableArray(copyContacterInfo), _toConsumableArray(addColor))));
  },
  deleteInfo: function deleteInfo(state, payload) {
    var copyContacterInfo = _toConsumableArray(state.contacterInfo[payload.contacterType]);
    state.contacterInfo[payload.contacterType] = copyContacterInfo.filter(function (listItem) {
      if (_typeof(listItem.item) === 'object') {
        // return !payload.data.includes(listItem.item)
        return listItem.item.openId !== payload.data[0].openId;
      } else if (typeof listItem.item === 'string') {
        var reslut = false;
        payload.data.forEach(function (sub) {
          if (sub.openId === listItem.item || sub === listItem.item) {
            reslut = true;
          }
        });
        return !reslut;
      }
      return true;
    });
  },
  addContacterOfWechat: function addContacterOfWechat(state, payload) {
    // 数据批量来的从第一个就可以知道是寄件人还是收件人, 整个存下来
    state.contacterWechat[payload[0].type] = payload;
  },
  removeContactWechat: function removeContactWechat(state, payload) {
    // 清空当前type(收件人，寄件人)的联系人信息中微信
    state.contacterWechat[payload] = [];
  },
  removeSendToWechat: function removeSendToWechat() {
    // 清空发送至微信
    state.contacterInfo.wechat = [];
  },
  ADD_PHONE: function ADD_PHONE(state, payload) {
    var val = payload.nickName.replace(/\s/g, '');
    if (!val) {
      state.contacterPhone[payload.type] = [];
      return;
    }
    state.contacterPhone[payload.type] = [val];
  },
  add_contacter: function add_contacter(state, payload) {
    var val = payload.nickName.replace(/\s/g, '');
    if (!val) {
      state.contacterEmail[payload.type] = [];
      return;
    }
    state.contacterEmail[payload.type] = [val];
  }
};
var actions = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};